export default {
    "Subtitles": "Sous-titres",
    "Disabled": "Désactivé",
    "af": "Afrikaans",
    "sq": "Albanais",
    "am": "Amharique",
    "ar": "Arabe",
    "hy": "Arménien",
    "as": "Assamais",
    "az": "Azéri",
    "ba": "Bachkir",
    "eu": "Basque",
    "be": "Biélorusse",
    "bn": "Bengali",
    "bs": "Bosniaque",
    "br": "Breton",
    "bg": "Bulgare",
    "ca": "Catalan",
    "zh": "Chinois",
    "hr": "Croate",
    "cs": "Tchèque",
    "da": "Danois",
    "nl": "Néerlandais",
    "en": "Anglais",
    "et": "Estonien",
    "fo": "Féroïen",
    "fi": "Finnois",
    "fr": "Français",
    "gl": "Galicien",
    "ka": "Géorgien",
    "de": "Allemand",
    "el": "Grec",
    "gu": "Gujarati",
    "ht": "Créole haïtien",
    "ha": "Haoussa",
    "haw": "Hawaïen",
    "he": "Hébreu",
    "hi": "Hindi",
    "hu": "Hongrois",
    "is": "Islandais",
    "id": "Indonésien",
    "it": "Italien",
    "ja": "Japonais",
    "jw": "Javanais",
    "kn": "Kannada",
    "kk": "Kazakh",
    "km": "Khmer",
    "ko": "Coréen",
    "lo": "Lao",
    "la": "Latin",
    "lv": "Letton",
    "ln": "Lingala",
    "lt": "Lituanien",
    "lb": "Luxembourgeois",
    "mk": "Macédonien",
    "mg": "Malgache",
    "ms": "Malais",
    "ml": "Malayalam",
    "mt": "Maltais",
    "mi": "Maori",
    "mr": "Marathi",
    "mn": "Mongol",
    "my": "Birman",
    "ne": "Népalais",
    "no": "Norvégien",
    "nn": "Nynorsk",
    "oc": "Occitan",
    "ps": "Pashto",
    "fa": "Persan",
    "pl": "Polonais",
    "pt": "Portugais",
    "pa": "Pendjabi",
    "ro": "Roumain",
    "ru": "Russe",
    "sa": "Sanskrit",
    "sr": "Serbe",
    "sn": "Shona",
    "sd": "Sindhi",
    "si": "Cingalais",
    "sk": "Slovaque",
    "sl": "Slovène",
    "so": "Somali",
    "es": "Espagnol",
    "su": "Soudanais",
    "sw": "Swahili",
    "sv": "Suédois",
    "tl": "Tagalog",
    "tg": "Tadjik",
    "ta": "Tamoul",
    "tt": "Tatar",
    "te": "Télougou",
    "th": "Thaï",
    "bo": "Tibétain",
    "tr": "Turc",
    "tk": "Turkmène",
    "uk": "Ukrainien",
    "ur": "Ourdou",
    "uz": "Ouzbek",
    "vi": "Vietnamien",
    "cy": "Gallois",
    "wo": "Wolof",
    "yi": "Yiddish",
    "yo": "Yoruba",
    "ace": "Acehnais",
    "an": "Aragonais",
    "ay": "Aymara",
    "bho": "Bhojpuri",
    "yue": "Cantonais",
    "ceb": "Cebuano",
    "zh-hans": "Chinois (simplifié)",
    "zh-hant": "Chinois (traditionnel)",
    "prs": "Dari",
    "en-gb": "Anglais (britannique)",
    "en-us": "Anglais (américain)",
    "eo": "Espéranto",
    "fr-ca": "Français (canadien)",
    "fr-fr": "Français (France)",
    "de-de": "Allemand (Allemagne)",
    "de-ch": "Allemand (suisse)",
    "gn": "Guarani",
    "ig": "Igbo",
    "ga": "Irlandais",
    "jv": "Javanais",
    "pam": "Kapampangan",
    "gom": "Konkani",
    "ckb": "Kurde (sorani)",
    "kmr": "Kurde (kurmanji)",
    "ky": "Kirghize",
    "lmo": "Lombard",
    "mai": "Maithili",
    "nb": "Norvégien (bokmål)",
    "om": "Oromo",
    "pag": "Pangasinan",
    "pt-br": "Portugais (brésilien)",
    "pt-pt": "Portugais (européen)",
    "qu": "Quechua",
    "st": "Sotho du Sud",
    "scn": "Sicilien",
    "es-419": "Espagnol (d'Amérique latine)",
    "ts": "Tsonga",
    "tn": "Tswana",
    "xh": "Xhosa",
    "zu": "Zoulou"
}
